import { NodeWrapper } from "./NodeWrapper";
import React, { memo } from "react";
import { Assignment as FormIcon } from '@mui/icons-material';
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { i18n } from "../../../translate/i18n";

import { Tooltip, IconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
  },
  arrow: { color: '#1e293b' },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  pulseIcon: {
    color: '#ffffff',
    borderRadius: '50%',
    animation: '$glowPulse 1.5s infinite',
  },
  '@keyframes glowPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.9)' },
    '70%': { boxShadow: '0 0 0 8px rgba(255, 255, 255, 0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' },
  },
}));

const COLOR = "#FFC400";

export default memo(({ data, isConnectable, id, selected }) => {
  const classes = useStyles();
  const storageItems = useNodeStorage();
  return (
    <NodeWrapper id={id} selected={selected} color={COLOR}>
      {/* Handle entrada */}
      <Handle type="target" position="left" style={{
        left: -12, top: "20px", background: COLOR, width: 10, height: 20,
        cursor: "pointer", borderRadius: "4px", border: "2px solid white", zIndex: 1
      }} isConnectable={isConnectable} />

      {/* Header */}
      <div style={{
        backgroundColor: COLOR, borderTopLeftRadius: "10px", borderTopRightRadius: "10px",
        padding: "0 12px", height: "40px", display: "flex", alignItems: "center", gap: "8px", justifyContent: 'space-between'
      }}>
        <FormIcon sx={{ width: "20px", height: "20px", color: "#ffffff", filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.7))" }} />
        <span style={{
          color: "#ffffff", fontSize: "14px", fontWeight: "700", letterSpacing: "0.3px", textShadow: "0px 1px 4px rgba(0,0,0,0.8)",
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", flexGrow: 1
        }}>
          {data.name || (i18n.t("flowBuilder.editor.nodes.form.name") || "Formulario Web")}
        </span>
      
        <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
          <HtmlTooltip
            title={
              <React.Fragment>
                <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#38bdf8' }}>
                  💡 {i18n.t("flowBuilder.tooltips.form.title")}
                </div>
                <div style={{ marginBottom: '0' }}>
                  <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.form.body") }} />
                </div>
              </React.Fragment>
            }
            placement="right"
          >
            <IconButton size="small" style={{ padding: '4px', marginLeft: '2px' }} className={classes.pulseIcon}>
              <HelpOutlineIcon style={{ fontSize: '15px' }} />
            </IconButton>
          </HtmlTooltip>
        </div>
      </div>

      {/* Body */}
      <div style={{ padding: "12px", backgroundColor: "#ffffff", borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }}>
        <div style={{
          position: "relative",
          backgroundColor: "#f8fafc", borderRadius: "8px", padding: "8px 10px",
          border: "1px solid #e2e8f0", fontSize: "12px", color: "#334155"
        }}>
          {data.formName
            ? <>📋 {data.formName}</>
            : <span style={{ color: "#94a3b8", fontStyle: "italic" }}>{i18n.t("flowBuilder.editor.nodes.form.noneSelected") || "Ninguno seleccionado"}</span>
          }
          <Handle type="source" position="right" id="a" style={{
            position: "absolute", right: -25, top: "50%", transform: "translateY(-50%)", background: COLOR, width: 10, height: 20,
            cursor: "pointer", borderRadius: "4px", border: "2px solid white", zIndex: 1
          }} isConnectable={isConnectable} />
        </div>

        {data.fields && data.fields.length > 0 && (
          <div style={{ marginTop: "8px" }}>
            <div style={{ fontSize: "10px", color: "#94a3b8", fontWeight: "700",
              textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "4px" }}>{i18n.t("flowBuilder.editor.nodes.form.collect") || "Recolectar:"}</div>
            <div style={{
              backgroundColor: "#f8fafc", borderRadius: "8px", padding: "8px 10px",
              border: "1px solid #e2e8f0", fontSize: "12px", color: "#334155"
            }}>
              {data.fields.map(f => f.label || f.name).join(", ")}
            </div>
          </div>
        )}
      </div>
    </NodeWrapper>
  );
});
